import { render, staticRenderFns } from "./ModalNotificacion.vue?vue&type=template&id=5ace2dd8&scoped=true"
import script from "./ModalNotificacion.vue?vue&type=script&lang=js"
export * from "./ModalNotificacion.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacion.vue?vue&type=style&index=0&id=5ace2dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace2dd8",
  null
  
)

export default component.exports